import type { UnsyncedWorkSummary } from '@/services/logout-guard.service';

/**
 * The T17 refusals, shared by the Logout button (AppStatusBar) and
 * "Sign out everywhere" (My account, L05 G-E3) so the words never drift.
 */
export interface LogoutToast {
  title: string;
  description: string;
  variant: 'warning';
}

// T17 (owner, Odoo rule): logout wipes this device, so it waits
// for every offline bill — pending, failed, dead or in conflict.
export function unsyncedBillsToast(count: number): LogoutToast {
  return {
    title: 'Sync pending bills first',
    description: `${count} offline item(s) are not on the server yet — waiting, failed or awaiting a manager. Open Sync to send them; logout stays blocked until then.`,
    variant: 'warning',
  };
}

// gst-parked 120: parks made offline upload to the store's list before logout.
export function unuploadedParksToast(count: number): LogoutToast {
  return {
    title: 'Upload parked bills first',
    description: `${count} parked bill(s) on this till are not on the server yet. Go back online so they upload, or open Parked Bills to resume or discard them; logout stays blocked until then.`,
    variant: 'warning',
  };
}

/** The toast for a logout refused for work that would be lost, or null when nothing blocks it. */
export function unsyncedWorkToast(
  u: Pick<UnsyncedWorkSummary, 'pending_sync' | 'parked_bills'> | undefined,
): LogoutToast | null {
  if ((u?.pending_sync ?? 0) > 0) return unsyncedBillsToast(u?.pending_sync ?? 0);
  if ((u?.parked_bills ?? 0) > 0) return unuploadedParksToast(u?.parked_bills ?? 0);
  return null;
}
